import { AlarmClassificationType } from 'sigma-mappings';

const alarmsClassificationsLookup = vm => ([
  {
    id: AlarmClassificationType.CRITICAL,
    name: vm.$t('reports.alarms-and-warnings.classification-types.critical'),
  },
  {
    id: AlarmClassificationType.URGENT,
    name: vm.$t('reports.alarms-and-warnings.classification-types.urgent'),
  },
  {
    id: AlarmClassificationType.ORDINARY,
    name: vm.$t('reports.alarms-and-warnings.classification-types.ordinary'),
  },
]);

export default alarmsClassificationsLookup;
